module.exports = __webpack_public_path__ + "static/media/hcm-district1.501aeb61.svg";